<script lang="ts">
    import { onDestroy, onMount, setContext } from 'svelte';

    import FiltersBar from '$saga/views/Home/FiltersBar.svelte';
    import SearchFormFields from '$saga/views/Search/components/SearchFormFields.svelte';
    import { filtersContext } from '$saga/views/Search/store';
    import {
        FILTER_CHANGE_CONTEXT,
        homeFilterChangeHandler,
        SEARCH_PAGE_FORM_ID,
    } from '$saga/views/Search/utils';

    export let title: string;
    export let isHybridSearchEnabled: boolean = false;

    // Any submit of these forms is a search, whichever button triggered it, so every search button shows its loader.
    const HOME_SEARCH_FORM_IDS = [
        SEARCH_PAGE_FORM_ID,
        'homepage-keywords-form',
    ];

    const markSubmitting = (event: SubmitEvent) => {
        const form = event.target as HTMLFormElement;
        if (HOME_SEARCH_FORM_IDS.includes(form.id)) {
            filtersContext.update((ctx) => ({ ...ctx, isSubmitting: true }));
        }
    };

    // A search page restored from the back/forward cache would otherwise keep its loaders.
    const resetSubmitting = () => {
        filtersContext.update((ctx) => ({ ...ctx, isSubmitting: false }));
    };

    setContext(FILTER_CHANGE_CONTEXT, homeFilterChangeHandler);

    // Capture phase: Turbo stops the submit while it bubbles through the form, before it reaches document.
    onMount(() => {
        document.addEventListener('submit', markSubmitting, true);
        window.addEventListener('pageshow', resetSubmitting);
    });

    onDestroy(() => {
        document.removeEventListener('submit', markSubmitting, true);
        window.removeEventListener('pageshow', resetSubmitting);
    });
</script>

<FiltersBar homeTitle={title} {isHybridSearchEnabled} />
<SearchFormFields />
